<div class="messages" *ngIf="messages.message$ | async as message">
  <div [ngClass]="messageType(message)">
    <div class="message-left">
      <mat-icon class="message-icon">{{ getMessageIcon(message.type) }}</mat-icon>
      <div class="message">{{ message.text }}</div>
    </div>

    <div class="filler"></div>

    <mat-icon class="close-icon" (click)="clearError()">close</mat-icon>
  </div>
</div>
